import React, { useState, useRef, useEffect } from "react";
import Grid from "@mui/material/Grid";
import {
  Button,
  FormControl,
  Select,
  MenuItem,
  Typography,
  Box,
  TextField,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Download } from "@mui/icons-material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import FormControlLabel from "@mui/material/FormControlLabel";
import countryList from "react-select-country-list";
import { useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import { number } from "currency-codes";
import { LoadingButton } from "@mui/lab";
import Checkbox from "@mui/material/Checkbox";
import Vector from "../../../../../assets/images/Vector.svg";
import insta from "../../../../../assets/images/insta.svg";
import linkedin from "../../../../../assets/images/linkedin.svg";
import fb from "../../../../../assets/images/fb.svg";
import DragAndDropInput from "../../../../../components/DragAndDropInput";
import CustomInput from "../../../../../components/CustomInput";
import { useForm } from "../../../../../hooks/useForm";
import { AddNewEmployeeValidation } from "../../../../../helper/Validation";
import { formatFormDate } from "../../../../../utils/DateFormat";
import DocumentUpload from "../../../../../components/DocumentUpload";
import { nationalities, updateProfileData } from "./data";
import { SPECIAL_PROJECTS } from "../../../../../constants/data";
import styles from "./style";

const EditEmployeePage = ({
  registerEmployee,
  userData,
  handleUrl,
  handleNavigate,
  loading,
  handleMultipleUrl,
  CountryCode,
  data,
  departmentData,
  operatorData,
  setDocument,
  document,
  payslip,
  getOneEmployee,
  oneEmloyeeData,
  projectList,
  handleExportPdf,
  handleExportSectionPdf,
}) => {
  const [mobile, setMobile] = useState(
    userData?.personalInfo?.mobile.toString()
  );
  const [emergency, setEmergency] = useState(
    userData?.otherInformation?.emergencyContact
      ? userData.otherInformation.emergencyContact.toString()
      : ""
  );
  const [workplace, setWorkplace] = useState(
    userData?.otherInformation?.workplace
      ? userData.otherInformation.workplace.toString()
      : ""
  );
  const [cCode, setCCode] = useState("");
  const [emergencyCode, setEmergencyCode] = useState("");
  const [workplaceCode, setWorkplaceCode] = useState("");
  const [selectedNationality, setSelectedNationality] = useState("");

  const handleChanges = (name, value) => {
    setSelectedNationality(value);
  };
  const mobileNumberRef = useRef(null);

  // Get profile data
  const updateProfile = updateProfileData(userData);
  const [sameAsPhysical, setSameAsPhysical] = useState(false);

  const [selectedPosition, setSelectedPosition] = useState(
    () => {
      const existing = updateProfile?.projects?.[0] ?? updateProfile?.projects?.value?.[0];
      if (!existing) return "";
      return typeof existing === "string" ? existing : existing?.name || "";
    }
  );
  const [docs1, setDocs1] = useState(updateProfile?.doc?.value);
  const [hasDocumentChanges, setHasDocumentChanges] = useState(false);
  const [hasFormChanges, setHasFormChanges] = useState(false);

  // Function to mark form as changed
  const markFormChanged = () => {
    if (!hasFormChanges) {
      setHasFormChanges(true);
    }
  };

const onRegister = (formData) => {
  const data = {
    ...formData,
    projects: {
      value: selectedPosition ? [selectedPosition] : [],
    },
  };

  data.password = {
    value: (formData?.password?.value || "").trim(),
  };

  data.confirmPassword = {
    value: (formData?.confirmPassword?.value || "").trim(),
  };

  registerEmployee(
    data,
    userData,
    mobile,
    cCode,
    emergency,
    emergencyCode,
    workplace,
    workplaceCode,
    selectedNationality
  );
  // Reset change flags
  setHasDocumentChanges(false);
  setHasFormChanges(false);
  getOneEmployee(userData?._id);
};

  const markDocumentChanged = () => {
    setHasDocumentChanges(true);
    setHasFormChanges(true);
  };

  const handleAddDoc = () => {
    markDocumentChanged();
    setDocs1([...docs1, { name: "", url: "" }]);
    setDocument([...document, { name: "", url: "" }]);
  };

  const handleDeleteDoc = (index) => {
    markDocumentChanged();
    const updatedDoc = [...docs1];
    const updatedDocument = [...document];
    updatedDoc.splice(index, 1);
    setDocs1(updatedDoc);
    updatedDocument.splice(index, 1);
    setDocument(updatedDocument);
  };

  const handleDocChange = (value, index, key) => {
    markDocumentChanged();
    setDocument((prevItems) => {
      const updatedItems = [...prevItems];
      updatedItems[index] = { ...updatedItems[index], [key]: value };
      return updatedItems;
    });
  };

  const navigate = useNavigate();
  const options = countryList().getData();

  const handleOnChanges = (value, country) => {
    setMobile(value);
    setCCode(country?.dialCode);
    markFormChanged();
  };

  const handleEmergencyChanges = (value, country) => {
    setEmergency(value);
    setEmergencyCode(country?.dialCode);
    markFormChanged();
  };

  const handleWorkplaceChanges = (value, country) => {
    setWorkplace(value);
    setWorkplaceCode(country?.dialCode);
    markFormChanged();
  };

  const { state, handleChange, handleSubmit, handleFocus } = useForm(
    updateProfile,
    AddNewEmployeeValidation,
    onRegister
  );

  const {
    firstName,
    lastName,
    gender,
    nickName,
    password,
    confirmPassword,
    jobPosition,
    department,
    operator,
    address1,
    address2,
    city,
    zipCode,
    country,
    email,
    dob,
    education,
    salary,
    religion,
    additionalBeneficiariesNo,
    marital,
    passportNum,
    hourlyRate,
    bankName,
    accountNum,
    ifscCode,
    accountHolder,
    personalTaxCode,
    joiningDate,
    experience,
    isActive,
    idNumber,
    taxRefNo,
    medicalAidNo,
    taskNoti,
    urlSkype,
    urlLinkedin,
    urlInsta,
    restraintTrade,
    isOverTime,
    isTracked,
    empType,
    start,
    end,
    rate,
    payfreq,
    paymentType,
    rateRembTravel,
    accountType,
    urlFb,
    isExtraTime,
    isDoubleOverTime,
    extraTimeRate,
    doubleOverTimeRate,
  } = state;

  // Custom handleChange wrapper to track changes
  const handleChangeWithTracking = (name, value, other) => {
    handleChange(name, value, other);

    // Keep paired fields in sync:
    // - ID/Pas Number <-> ID Number
    // - Personal Income Tax <-> Tax Ref. No
    if (name === "passportNum") {
      handleChange("idNumber", value);
    } else if (name === "idNumber") {
      handleChange("passportNum", value);
    } else if (name === "personalTaxCode") {
      handleChange("taxRefNo", value);
    } else if (name === "taxRefNo") {
      handleChange("personalTaxCode", value);
    } else if (name === "address1" && sameAsPhysical) {
      handleChange("address2", value);
    }

    markFormChanged();
  };

  const handleSameAsPhysicalChange = (e) => {
    const checked = e.target.checked;
    setSameAsPhysical(checked);
    if (checked) {
      handleChangeWithTracking("address2", address1?.value || updateProfile?.address1?.value || "");
    }
  };

  // Track nationality changes
  const handleNationalityChange = (value) => {
    setSelectedNationality(value);
    markFormChanged();
  };

  // Track project changes  
  const handleProjectChange = (value) => {
    setSelectedPosition(value);
    markFormChanged();
  };

  return (
    <Box sx={{ pl: 2 }}>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Box sx={styles.mainGrid}>
          <Typography sx={styles.heading} variant="h4"></Typography>
          <Button
            variant="contained"
            type="submit"
            color="success"
            sx={styles.additionalButtons}
            onClick={() =>
              navigate("/dashboard/additionalInfo", {
                state: { userData, oneEmloyeeData },
              })
            }
          >
            Additional Informations
          </Button>
        </Box>
        <Grid container display="flex" flexDirection="row">
          <Grid item lg={6} sm={12}>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              ml="2%"
              mt="2%"
              mb="2%"
            >
              <Box
                sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
              ></Box>
              <Typography sx={styles.textsize}>Personal Information</Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={styles.card}>
                <Box display="flex" justifyContent="flex-end" mb={1}>
                  <Button
                    type="button"
                    onClick={() => handleExportSectionPdf("personal_info")}
                    sx={styles.exportBtn}
                  >
                    <Download />
                    Export Pdf
                  </Button>
                </Box>
                <Grid container spacing={1}>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      mb: "2%",
                      height: "5em",
                    }}
                  >
                    <DragAndDropInput
                      profileImg={updateProfile?.profileImg?.value}
                      handleUrl={(file) => {
                        handleUrl(file);
                      }}
                      isFrom={"edit"}
                    />
                    <Typography sx={styles.changeText}>
                      {"Change Profile Photo"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      First Name<span style={{ color: "red" }}>*</span>
                    </Typography>
                    <CustomInput
                      sx={styles.inputsize}
                      defaultValue={updateProfile?.firstName?.value}
                      name="firstName"
                      value={firstName?.value}
                      onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      error={firstName?.error}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      Surname<span style={{ color: "red" }}>*</span>
                    </Typography>
                    <CustomInput
                      name="lastName"
                      defaultValue={updateProfile?.lastName?.value}
                      value={lastName?.value}
                      onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      error={lastName?.error}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>Nick Name</Typography>
                    <CustomInput
                      name="nickName"
                      defaultValue={updateProfile?.nickName?.value}
                      value={nickName?.value}
                      onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      error={nickName?.error}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Typography sx={styles.textsize}>
                        Date Of Birth<span style={{ color: "red" }}>*</span>
                      </Typography>
                      <DatePicker
                        name="dob"
                        value={dob.value ? dayjs(dob.value) : (updateProfile?.dob?.value ? dayjs(updateProfile?.dob?.value) : null)}
                        maxDate={dayjs().subtract(16, "year")}
                        onChange={(newValue) => {
                          handleChangeWithTracking(
                            "dob",
                            newValue ? newValue.format("YYYY-MM-DD") : null
                          );
                        }}
                        error={dob.error}
                        sx={styles.dateInput}
                        slotProps={{
                          field: {
                            readOnly: true,
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl
                      fullWidth
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "2.9em",
                          marginTop: "0.5em",
                          borderRadius: "10px",
                        },
                      }}
                    >
                      <Typography sx={styles.textsize}>
                        Nationality<span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Select
                        value={selectedNationality || updateProfile?.nationality?.value}
                        onChange={(e) => {
                          handleNationalityChange(e.target.value);
                        }}
                        name="nationality"
                        onFocus={handleFocus}
                        defaultValue={updateProfile?.nationality?.value}
                        sx={styles.dropDownMenu}
                        placeholder={updateProfile?.nationality?.value}
                      >
                        {nationalities?.map((item, index) => (
                          <MenuItem
                            key={index}
                            sx={styles.dropDownMenu}
                            value={item}
                          >
                            {item}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      Id/Pas Number<span style={{ color: "red" }}>*</span>
                    </Typography>
                    <CustomInput
                      fullWidth
                      name="passportNum"
                      defaultValue={updateProfile?.passportNum.value}
                      value={passportNum?.value}
                      onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      error={passportNum.error}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl
                      fullWidth
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "2.9em",
                          marginTop: "0.5em",
                          borderRadius: "10px",
                        },
                      }}
                    >
                      <Typography sx={styles.textsize}>
                        Gender<span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Select
                        defaultValue={updateProfile?.gender?.value}
                        value={
                          gender.value
                            ? gender?.value
                            : updateProfile?.gender?.value
                        }
                        onChange={(e) => handleChangeWithTracking("gender", e.target.value)}
                        name="gender"
                        onFocus={handleFocus}
                        error={gender?.error}
                        sx={styles.dropDownMenu}
                      >
                        <MenuItem sx={styles.dropDownMenu} value="male">
                          Male
                        </MenuItem>
                        <MenuItem sx={styles.dropDownMenu} value="female">
                          Female
                        </MenuItem>
                        <MenuItem sx={styles.dropDownMenu} value="other">
                          Other
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth sx={styles.mobileGrid}>
                      <Typography sx={styles.textsize}>
                        Mobile<span style={{ color: "red" }}>*</span>
                      </Typography>
                      <PhoneInput
                        country={"za"}
                        enableSearch={true}
                        defaultValue={
                          cCode || updateProfile?.mobile?.value?.toString()
                        }
                        value={mobile}
                        name="mobile"
                        onChange={(value, country) =>
                          handleOnChanges(value, country)
                        }
                        onFocus={handleFocus}
                        ref={mobileNumberRef}
                        error={mobile.error}
                        sx={styles.mobile}
                        inputProps={{
                          style: {
                            height: "1em",
                            borderRadius: "10px",
                          },
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      Password
                    </Typography>
                    <CustomInput
                      name="password"
                      type="password"
                      value={password?.value}
                      onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      error={password.error}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      Confirm Password
                    </Typography>
                    <CustomInput
                      name="confirmPassword"
                      type="password"
                      value={confirmPassword?.value}
                      onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      error={confirmPassword.error}
                      matchPassword={password.value}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      Job Position<span style={{ color: "red" }}>*</span>
                    </Typography>
                    <CustomInput
                      name="jobPosition"
                      value={jobPosition?.value}
                      defaultValue={updateProfile?.jobPosition?.value}
                      onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      error={jobPosition?.error}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl
                      fullWidth
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "2.9em",
                          marginTop: "0.5em",
                          borderRadius: "10px",
                        },
                      }}
                    >
                      <Typography sx={styles.textsize}>
                        Department<span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Select
                        defaultValue={updateProfile?.department?.value}
                        value={department.value}
                        onChange={(e) => handleChangeWithTracking("department", e.target.value)}
                        name="department"
                        onFocus={handleFocus}
                        error={department?.error}
                        sx={styles.dropDownMenu}
                      >
                        {departmentData?.map((item, index) => (
                          <MenuItem
                            key={index}
                            sx={styles.dropDownMenu}
                            value={item?.name}
                          >
                            {item?.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl
                      fullWidth
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "2.9em",
                          marginTop: "0.5em",
                          borderRadius: "10px",
                        },
                      }}
                    >
                      <Typography sx={styles.textsize}>
                        Role Type<span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Select
                        defaultValue={updateProfile?.operator?.value}
                        value={operator?.value}
                        onChange={(e) => handleChangeWithTracking("operator", e.target.value)}
                        name="operator"
                        onFocus={handleFocus}
                        error={operator?.error}
                        displayEmpty
                        sx={styles.dropDownMenu}
                      >
                        <MenuItem disabled value="">
                          Select
                        </MenuItem>
                        {operatorData?.map((item, index) => (
                          <MenuItem
                            key={index}
                            sx={styles.dropDownMenu}
                            value={item?.name}
                          >
                            {item?.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      Physical Address<span style={{ color: "red" }}>*</span>
                    </Typography>
                    <CustomInput
                      name="address1"
                      defaultValue={updateProfile?.address1?.value}
                      value={address1?.value}
                      onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      multiline
                      error={address1?.error}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      Postal Address<span style={{ color: "red" }}>*</span>
                    </Typography>
                    <CustomInput
                      name="address2"
                      defaultValue={updateProfile?.address2?.value}
                      value={address2?.value}
                      onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      multiline
                      error={address2?.error}
                      disabled={sameAsPhysical}
                    />
                    <FormControlLabel
                      sx={styles.formControlLabel}
                      control={
                        <Checkbox
                          checked={sameAsPhysical}
                          onChange={handleSameAsPhysicalChange}
                        />
                      }
                      label="Postal address same as physical address"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      City<span style={{ color: "red" }}>*</span>
                    </Typography>
                    <CustomInput
                      name="city"
                      defaultValue={updateProfile?.city?.value}
                      value={city?.value}
                      onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      error={city?.error}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      Zip Code<span style={{ color: "red" }}>*</span>
                    </Typography>
                    <CustomInput
                      name="zipCode"
                      defaultValue={updateProfile?.zipCode?.value}
                      value={zipCode?.value}
                      onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      error={zipCode?.error}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl
                      fullWidth
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "2.8em",
                          marginTop: "0.5em",
                          borderRadius: "10px",
                        },
                      }}
                    >
                      <Typography sx={styles.textsize} shrink={true}>
                        Country<span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Select
                        defaultValue={updateProfile?.country?.value}
                        value={country?.value}
                        onChange={(event) => {
                          handleChangeWithTracking("country", event.target.value);
                          CountryCode(event.target.value);
                        }}
                        name="country"
                        sx={styles.dropDownMenu}
                        onFocus={handleFocus}
                        error={country.error}
                      >
                        {options.map((country, index) => (
                          <MenuItem
                            key={index}
                            sx={styles.dropDownMenu}
                            value={country.label}
                          >
                            {country.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      Email<span style={{ color: "red" }}>*</span>
                    </Typography>
                    <CustomInput
                      name="email"
                      defaultValue={updateProfile?.email?.value}
                      value={email?.value}
                      onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      error={email?.error}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      Education<span style={{ color: "red" }}>*</span>
                    </Typography>
                    <CustomInput
                      name="education"
                      defaultValue={updateProfile?.education.value}
                      value={education?.value}
                      onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      error={education.error}
                    />
                  </Grid>
                  {/* <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      Employee Id<span style={{ color: "red" }}>*</span>
                    </Typography>
                    <CustomInput
                      name="empNumber"
                      defaultValue={updateProfile?.empNumber.value}
                      value={empNumber?.value}
                     onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      error={empNumber.error}
                    />
                  </Grid> */}
                  <Grid item xs={12}>
                    <FormControlLabel
                      sx={styles.formControlLabel}
                      control={
                        <Checkbox
                          defaultChecked={updateProfile?.isActive?.value}
                          checked={isActive?.value}
                          onChange={(e) => {
                            handleChangeWithTracking("isActive", e.target.checked);
                          }}
                        />
                      }
                      label="Is Active"
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              ml="2%"
              mt="2%"
              mb="2%"
            >
              <Box
                sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
              ></Box>
              <Typography sx={styles.textsize}>Additional Options</Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={styles.card}>
                <Box display="flex" justifyContent="flex-end" mb={1}>
                  <Button
                    type="button"
                    onClick={() => handleExportSectionPdf("additional_options")}
                    sx={styles.exportBtn}
                  >
                    <Download />
                    Export Pdf
                  </Button>
                </Box>
                <Grid container spacing={1} sx={{ display: "block" }}>
                  <Grid>
                    <FormControlLabel
                      sx={styles.formControlLabel}
                      control={
                        <Checkbox
                          defaultChecked={updateProfile?.taskNoti.value}
                          checked={taskNoti?.value}
                          onChange={(e) => {
                            handleChangeWithTracking("taskNoti", e.target.checked);
                          }}
                        />
                      }
                      label="New Task Notifications"
                    />
                  </Grid>
                  <Grid>
                    <FormControlLabel
                      sx={styles.formControlLabel}
                      control={
                        <Checkbox
                          defaultChecked={updateProfile?.isTracked?.value}
                          checked={isTracked?.value}
                          onChange={(e) => {
                            handleChangeWithTracking("isTracked", e.target.checked);
                          }}
                        />
                      }
                      label="Is Tracked"
                    />
                  </Grid>
                  <Grid>
                    <FormControlLabel
                      sx={styles.formControlLabel}
                      control={
                        <Checkbox
                          defaultChecked={updateProfile?.isOverTime?.value}
                          checked={isOverTime?.value}
                          onChange={(e) => {
                            handleChange("isOverTime", e.target.checked);
                          }}
                        />
                      }
                      label="Allow Overtime"
                    />
                  </Grid>
                  {isOverTime?.value && (
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>eg Rate x 1.5</Typography>
                      <CustomInput
                        fullWidth
                        name="rate"
                        placeholder={"0.0"}
                        value={rate?.value}
                        defaultValue={updateProfile?.rate?.value}
                        onChange={handleChangeWithTracking}
                        onFocus={handleFocus}
                        error=""
                      />
                    </Grid>
                  )}
                  <Grid>
                    <FormControlLabel
                      sx={styles.formControlLabel}
                      control={
                        <Checkbox
                          defaultChecked={
                            updateProfile?.isDoubleOverTime?.value
                          }
                          checked={isDoubleOverTime?.value}
                          onChange={(e) => {
                            handleChange("isDoubleOverTime", e.target.checked);
                          }}
                        />
                      }
                      label="Allow DoubleOverTime"
                    />
                  </Grid>
                  {isDoubleOverTime?.value && (
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>eg Rate x 2</Typography>
                      <CustomInput
                        fullWidth
                        name="doubleOverTimeRate"
                        placeholder={"0.0"}
                        value={doubleOverTimeRate?.value}
                        defaultValue={updateProfile?.doubleOverTimeRate.value}
                        onChange={handleChangeWithTracking}
                        onFocus={handleFocus}
                        error=""
                      />
                    </Grid>
                  )}
                  <Grid>
                    <FormControlLabel
                      sx={styles.formControlLabel}
                      control={
                        <Checkbox
                          defaultChecked={updateProfile?.isExtraTime?.value}
                          checked={isExtraTime?.value}
                          onChange={(e) => {
                            handleChange("isExtraTime", e.target.checked);
                          }}
                        />
                      }
                      label="Allow ExtraTime"
                    />
                  </Grid>
                  {isExtraTime?.value && (
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>eg Rate x 1.3</Typography>
                      <CustomInput
                        fullWidth
                        name="extraTimeRate"
                        placeholder={"0.0"}
                        value={extraTimeRate?.value}
                        defaultValue={updateProfile?.extraTimeRate.value}
                        onChange={handleChangeWithTracking}
                        onFocus={handleFocus}
                        error=""
                      />
                    </Grid>
                  )}
                  {/* <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      Number Of Additional beneficiaries
                    </Typography>
                    <CustomInput
                      fullWidth
                      name="additionalBeneficiariesNo"
                      defaultValue={
                        updateProfile?.additionalBeneficiariesNo?.value
                      }
                      value={additionalBeneficiariesNo?.value}
                      onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      error={additionalBeneficiariesNo.error}
                    />
                  </Grid> */}
                </Grid>
              </Grid>
            </Grid>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              ml="2%"
              mt="2%"
              mb="2%"
            >
              <Box
                sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
              ></Box>
              <Typography sx={styles.textsize}>Other Information</Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={styles.card}>
                <Box display="flex" justifyContent="flex-end" mb={1}>
                  <Button
                    type="button"
                    onClick={() => handleExportSectionPdf("other_info")}
                    sx={styles.exportBtn}
                  >
                    <Download />
                    Export Pdf
                  </Button>
                </Box>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>Religion</Typography>
                    <CustomInput
                      fullWidth
                      name="religion"
                      defaultValue={updateProfile?.religion?.value}
                      value={religion?.value}
                      onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      error={religion.error}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl
                      fullWidth
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "2.9em",
                          marginTop: "0.5em",
                          borderRadius: "10px",
                        },
                      }}
                    >
                      <Typography sx={styles.textsize}>Marital</Typography>
                      <Select
                        defaultValue={updateProfile?.marital?.value}
                        value={
                          marital?.value
                            ? marital?.value
                            : updateProfile?.marital.value
                        }
                        onChange={(e) => {
                          handleChange("marital", e.target.value);
                        }}
                        name="Marital"
                        placeholder="Marital"
                        handleFocus={handleFocus}
                        error={marital?.error}
                        sx={styles.dropDownMenu}
                      >
                        <MenuItem sx={styles.dropDownMenu} value="Yes">
                          Yes
                        </MenuItem>
                        <MenuItem sx={styles.dropDownMenu} value="No">
                          No
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth sx={styles.mobileGrid}>
                      <Typography sx={styles.textsize}>
                        Emergency Contact
                      </Typography>
                      <PhoneInput
                        country={"za"}
                        enableSearch={true}
                        defaultValue={
                          emergencyCode ||
                          updateProfile?.emergencyContact?.value?.toString() ||
                          ""
                        }
                        value={emergency}
                        name="mobile"
                        onChange={(value, country) =>
                          handleEmergencyChanges(value, country)
                        }
                        onFocus={handleFocus}
                        ref={mobileNumberRef}
                        error={mobile.error}
                        sx={styles.mobile}
                        inputProps={{
                          style: {
                            height: "1em",
                            borderRadius: "10px",
                          },
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth sx={styles.mobileGrid}>
                      <Typography sx={styles.textsize}>Workplace</Typography>
                      <PhoneInput
                        country={"za"}
                        enableSearch={true}
                        defaultValue={
                          workplaceCode ||
                          updateProfile?.workplace?.value?.toString()
                        }
                        value={workplace}
                        name="mobile"
                        onChange={(value, country) =>
                          handleWorkplaceChanges(value, country)
                        }
                        onFocus={handleFocus}
                        ref={mobileNumberRef}
                        error={mobile.error}
                        sx={styles.mobile}
                        inputProps={{
                          style: {
                            height: "1em",
                            borderRadius: "10px",
                          },
                        }}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={6} sm={12}>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              ml="2%"
              mt="2%"
              mb="2%"
            >
              <Box
                sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
              ></Box>
              <Typography sx={styles.textsize}>Salary Information</Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={styles.card}>
                <Box display="flex" justifyContent="flex-end" mb={1}>
                  <Button
                    type="button"
                    onClick={() => handleExportSectionPdf("salary_info")}
                    sx={styles.exportBtn}
                  >
                    <Download />
                    Export Pdf
                  </Button>
                </Box>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      Salary<span style={{ color: "red" }}>*</span>
                    </Typography>
                    <CustomInput
                      name="salary"
                      defaultValue={updateProfile?.salary.value}
                      value={salary.value}
                      onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      error={salary.error}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl
                      fullWidth
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "2.9em",
                          marginTop: "0.5em",
                          borderRadius: "10px",
                        },
                      }}
                    >
                      <Typography sx={styles.textsize}>
                        Rate<span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Select
                        defaultValue={updateProfile?.hourlyRate?.value}
                        value={
                          hourlyRate?.value
                            ? hourlyRate?.value
                            : updateProfile?.hourlyRate.value
                        }
                        onChange={(e) => {
                          handleChange("hourlyRate", e.target.value);
                        }}
                        name="hourlyRate"
                        handleFocus={handleFocus}
                        error={hourlyRate?.error}
                        sx={styles.dropDownMenu}
                      >
                        <MenuItem sx={styles.dropDownMenu} value="Hourly">
                          Hourly
                        </MenuItem>
                        <MenuItem sx={styles.dropDownMenu} value="Salary">
                          Salary
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      Restraint Of Trade
                    </Typography>
                    <CustomInput
                      fullWidth
                      name="restraintTrade"
                      defaultValue={updateProfile?.restraintTrade.value}
                      value={restraintTrade?.value}
                      onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      error={restraintTrade.error}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth sx={styles.formControl}>
                      <Typography sx={styles.textsize} shrink={true}>
                        Pay Frequency<span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Select
                        defaultValue={updateProfile?.payfreq?.value}
                        value={
                          payfreq?.value
                            ? payfreq?.value
                            : updateProfile?.payfreq.value
                        }
                        onChange={(e) => handleChange("payfreq", e.target.value)}
                        name="payfreq"
                        sx={styles.dropDownMenu}
                        displayEmpty
                      >
                        <MenuItem disabled value="">
                          Select
                        </MenuItem>
                        <MenuItem sx={styles.dropDownMenu} value="Monthly">
                          Monthly
                        </MenuItem>
                        <MenuItem sx={styles.dropDownMenu} value="Weekly">
                          Weekly
                        </MenuItem>
                        <MenuItem sx={styles.dropDownMenu} value="Fortnight">
                          Fortnight
                        </MenuItem>
                        <MenuItem sx={styles.dropDownMenu} value="Custom">
                          Custom
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth sx={styles.formControl}>
                      <Typography sx={styles.textsize} shrink={true}>
                        Payment Type<span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Select
                        defaultValue={updateProfile?.paymentType?.value}
                        value={
                          paymentType?.value
                            ? paymentType?.value
                            : updateProfile?.paymentType.value
                        }
                        onChange={(e) => handleChange("paymentType", e.target.value)}
                        name="paymentType"
                        sx={styles.dropDownMenu}
                        displayEmpty
                      >
                        <MenuItem disabled value="">
                          Select
                        </MenuItem>
                        <MenuItem sx={styles.dropDownMenu} value="Cash">
                          Cash
                        </MenuItem>
                        <MenuItem sx={styles.dropDownMenu} value="Cheque">
                          Cheque
                        </MenuItem>
                        <MenuItem sx={styles.dropDownMenu} value="Transfer">
                          Transfer
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Typography sx={styles.textsize}>
                      Rate Per Kilometre On Reimbursive Travel
                      <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <CustomInput
                      fullWidth
                      name="rateRembTravel"
                      defaultValue={updateProfile?.rateRembTravel.value}
                      value={rateRembTravel?.value}
                      onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      error={rateRembTravel.error}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              ml="2%"
              mt="2%"
              mb="2%"
            >
              <Box
                sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
              ></Box>
              <Typography sx={styles.textsize}>Bank Information</Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={styles.card}>
                <Box display="flex" justifyContent="flex-end" mb={1}>
                  <Button
                    type="button"
                    onClick={() => handleExportSectionPdf("bank_info")}
                    sx={styles.exportBtn}
                  >
                    <Download />
                    Export Pdf
                  </Button>
                </Box>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      Bank Name<span style={{ color: "red" }}>*</span>
                    </Typography>
                    <CustomInput
                      fullWidth
                      name="bankName"
                      defaultValue={updateProfile?.bankName.value}
                      value={bankName?.value}
                      onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      error={bankName.error}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      Account<span style={{ color: "red" }}>*</span>
                    </Typography>
                    <CustomInput
                      fullWidth
                      name="accountNum"
                      defaultValue={updateProfile?.accountNum.value}
                      value={accountNum?.value}
                      onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      error={accountNum.error}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      {country === "India"
                        ? "Name IFSC"
                        : data?.bankCode || "Branch Code"}
                    </Typography>
                    <CustomInput
                      fullWidth
                      name="ifscCode"
                      value={ifscCode?.value}
                      defaultValue={updateProfile?.ifscCode.value}
                      onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      error={ifscCode.error}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      Account Holder<span style={{ color: "red" }}>*</span>
                    </Typography>
                    <CustomInput
                      fullWidth
                      name="accountHolder"
                      defaultValue={updateProfile?.accountHolder.value}
                      onChange={handleChangeWithTracking}
                      value={accountHolder?.value}
                      onFocus={handleFocus}
                      error={accountHolder.error}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      Account Type<span style={{ color: "red" }}>*</span>
                    </Typography>
                    <CustomInput
                      fullWidth
                      name="accountType"
                      defaultValue={updateProfile?.accountType.value}
                      onChange={handleChangeWithTracking}
                      value={accountType?.value}
                      onFocus={handleFocus}
                      error={accountType.error}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      {country === "India"
                        ? "Name GST "
                        : data?.taxCode || "Personal Income Tax"}
                    </Typography>
                    <CustomInput
                      fullWidth
                      type={number}
                      name="personalTaxCode"
                      defaultValue={updateProfile?.personalTaxCode.value}
                      value={personalTaxCode?.value}
                      onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      error={personalTaxCode.error}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              ml="2%"
              mt="2%"
              mb="2%"
            >
              <Box
                sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
              ></Box>
              <Typography sx={styles.textsize}>Experience</Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={styles.card}>
                <Box display="flex" justifyContent="flex-end" mb={1}>
                  <Button
                    type="button"
                    onClick={() => handleExportSectionPdf("experience")}
                    sx={styles.exportBtn}
                  >
                    <Download />
                    Export Pdf
                  </Button>
                </Box>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      Joining Date<span style={{ color: "red" }}>*</span>
                    </Typography>
                    <CustomInput
                      fullWidth
                      name="joiningDate"
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      defaultValue={formatFormDate(
                        updateProfile?.joiningDate.value
                      )}
                      value={joiningDate.value}
                      onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      error={joiningDate.error}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      Total Years Of Experience
                      <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <CustomInput
                      fullWidth
                      name="experience"
                      defaultValue={updateProfile?.experience.value}
                      value={experience?.value}
                      onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      error={experience.error}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              ml="2%"
              mt="2%"
              mb="2%"
            >
              <Box
                sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
              ></Box>
              <Typography sx={styles.textsize}>Employee Type</Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={styles.card}>
                <Box display="flex" justifyContent="flex-end" mb={1}>
                  <Button
                    type="button"
                    onClick={() => handleExportSectionPdf("employee_type")}
                    sx={styles.exportBtn}
                  >
                    <Download />
                    Export Pdf
                  </Button>
                </Box>
                <Grid container spacing={1} mr={4}>
                  <Grid item xs={12} sm={6}>
                    <FormControl
                      fullWidth
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "2.8em",
                          marginTop: "0.5em",
                          borderRadius: "10px",
                          mb: 1,
                          ml: -0.7,
                        },
                      }}
                    >
                      <Typography sx={styles.textsize} shrink={true}>
                        Choose Employee Type<span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Select
                        defaultValue={updateProfile?.empType?.value}
                        value={
                          empType.value
                            ? empType?.value
                            : updateProfile?.empType?.value
                        }
                        onChange={(e) => {
                          handleChange("empType", e.target.value);
                        }}
                        name="empType"
                        sx={styles.dropDownMenu}
                        onFocus={handleFocus}
                        error={empType.error}
                        displayEmpty
                      >
                        <MenuItem disabled value="">
                          Select
                        </MenuItem>
                        <MenuItem sx={styles.dropDownMenu} value="director">
                          Director
                        </MenuItem>
                        <MenuItem sx={styles.dropDownMenu} value="employee">
                          Employee
                        </MenuItem>
                        <MenuItem sx={styles.dropDownMenu} value="contractor">
                          Contractor
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} ms={10}>
                    <FormControl
                      fullWidth
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "2.8em",
                          marginTop: "0.5em",
                          borderRadius: "10px",
                          mb: 1,
                        },
                      }}
                    >
                      <Typography shrink={true} sx={styles.textsize}>
                        Position
                      </Typography>
                      <Select
                        fullWidth
                        name="projects"
                        value={selectedPosition}
                        onChange={(e) => {
                          const val = e.target.value;
                          handleProjectChange(val);
                          handleChangeWithTracking("projects", {
                            value: val ? [val] : []
                          });
                        }}
                        sx={styles.dropDownMenu}
                        displayEmpty
                        renderValue={(selected) => {
                          if (!selected) {
                            return <span style={{ color: "#aaa" }}>Select Position</span>;
                          }
                          return selected;
                        }}
                      >
                        <MenuItem value="" disabled style={styles.dropdownMenu}>Select</MenuItem>
                        <MenuItem value="Casual" style={styles.dropdownMenu}>Casual</MenuItem>
                        <MenuItem value="Permanent" style={styles.dropdownMenu}>Permanent</MenuItem>
                        <MenuItem value="Contract" style={styles.dropdownMenu}>Contract</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  {empType.value === "contractor" && (
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={6}>
                        <Typography sx={styles.textsize}>Start</Typography>
                        <CustomInput
                          fullWidth
                          name="start"
                          type="date"
                          InputLabelProps={{ shrink: true }}
                          defaultValue={formatFormDate(
                            updateProfile?.start.value
                          )}
                          value={start?.value}
                          onChange={handleChangeWithTracking}
                          onFocus={handleFocus}
                          error={start.error}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography sx={styles.textsize}>End</Typography>
                        <CustomInput
                          fullWidth
                          name="end"
                          type="date"
                          InputLabelProps={{ shrink: true }}
                          defaultValue={formatFormDate(
                            updateProfile?.end.value
                          )}
                          value={end?.value}
                          onChange={handleChangeWithTracking}
                          onFocus={handleFocus}
                          error={end?.error}
                        />
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              ml="2%"
              mt="2%"
              mb="2%"
            >
              <Box
                sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
              ></Box>
              <Typography sx={styles.textsize}>Tax Information</Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={styles.card}>
                <Box display="flex" justifyContent="flex-end" mb={1}>
                  <Button
                    type="button"
                    onClick={() => handleExportSectionPdf("tax_info")}
                    sx={styles.exportBtn}
                  >
                    <Download />
                    Export Pdf
                  </Button>
                </Box>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      ID Number <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <CustomInput
                      fullWidth
                      name="idNumber"
                      placeholder={"ID Number"}
                      defaultValue={updateProfile?.idNumber?.value}
                      value={idNumber?.value}
                      onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      error={idNumber?.error}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      Tax Ref. No
                    </Typography>
                    <CustomInput
                      fullWidth
                      name="taxRefNo"
                      placeholder={"Tax Ref. No"}
                      defaultValue={updateProfile?.taxRefNo?.value}
                      value={taxRefNo?.value}
                      onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      error={taxRefNo?.error}
                    />
                  </Grid>
                  {/* UIF Number field removed as per requirements */}
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>Medical Aid No</Typography>
                    <CustomInput
                      fullWidth
                      name="medicalAidNo"
                      placeholder={"Medical Aid No"}
                      defaultValue={updateProfile?.medicalAidNo?.value}
                      value={medicalAidNo?.value}
                      onChange={handleChangeWithTracking}
                      onFocus={handleFocus}
                      error={medicalAidNo?.error}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              ml="2%"
              mt="2%"
              mb="2%"
            >
              <Box
                sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
              ></Box>
              <Typography sx={styles.subTitle}>Documents</Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={styles.card}>
                <Box display="flex" justifyContent="flex-end" mb={1}>
                  <Button
                    type="button"
                    onClick={() => handleExportSectionPdf("documents")}
                    sx={styles.exportBtn}
                  >
                    <Download />
                    Export Pdf
                  </Button>
                </Box>
                <Grid container spacing={2} sx={{ display: "flex-wrap" }}>
                  {docs1?.map((item, index) => (
                    <>
                      <Grid item xs={4.5} key={index}>
                        <DocumentUpload
                          name="url"
                          handleUrl={(file) => {
                            markDocumentChanged();
                            setDocs1((prevDocs) => [...prevDocs, file]);
                          }}
                          docs={docs1}
                          setDocs={setDocs1}
                          value={docs1}
                          fileName={document[index]?.name || item?.name}
                          image={item?.url}
                          handleimage={(val) => {
                            markDocumentChanged();
                            handleMultipleUrl(val, index);
                          }}
                          onChange={(e) => {
                            handleDocChange(e.target.value, index, "url");
                          }}
                        />
                        <Box>
                          <TextField
                            sx={{ py: "0px" }}
                            name="name"
                            placeholder="File Name"
                            value={document[index]?.name || item?.name}
                            onChange={(e) => {
                              handleDocChange(e.target.value, index, "name");
                            }}
                          ></TextField>
                        </Box>
                      </Grid>
                      <Grid item xs={2} lg={1.5} sx={styles.secondGrid}>
                        <Box sx={styles.btnGridAction}>
                          {index === 0 && (
                            <Box sx={styles.addIcons} onClick={handleAddDoc}>
                              +
                            </Box>
                          )}
                          {index !== 0 && (
                            <Box
                              sx={styles.deleteIcons}
                              onClick={() => handleDeleteDoc(index)}
                            >
                              <DeleteOutlineIcon />
                            </Box>
                          )}
                        </Box>
                      </Grid>
                    </>
                  ))}
                </Grid>
                <Box></Box>
              </Grid>
            </Grid>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              ml="2%"
              mt="2%"
              mb="2%"
            >
              <Box
                sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
              ></Box>
              <Typography sx={styles.textsize}>Social Media</Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={styles.card}>
                <Box display="flex" justifyContent="flex-end" mb={1}>
                  <Button
                    type="button"
                    onClick={() => handleExportSectionPdf("social_media")}
                    sx={styles.exportBtn}
                  >
                    <Download />
                    Export Pdf
                  </Button>
                </Box>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6} lg={6}>
                    <Typography sx={styles.textside}>Paste Url Skype</Typography>
                    <Box display="flex">
                      <img
                        src={Vector}
                        alt="Skype"
                        style={{ marginRight: "5%" }}
                      />
                      <CustomInput
                        name="urlSkype"
                        defaultValue={updateProfile?.urlSkype.value}
                        onChange={handleChangeWithTracking}
                        value={urlSkype?.value}
                        onFocus={handleFocus}
                        error={urlSkype.error}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6} lg={6}>
                    <Typography sx={styles.textside}>
                      Paste Url LinkedIn
                    </Typography>
                    <Box display="flex">
                      <img
                        src={linkedin}
                        alt="linkedIn"
                        style={{ marginRight: "5%" }}
                      />
                      <CustomInput
                        name="urlLinkedin"
                        defaultValue={updateProfile?.urlLinkedin.value}
                        value={urlLinkedin?.value}
                        onChange={handleChangeWithTracking}
                        onFocus={handleFocus}
                        error={urlLinkedin.error}
                        sx={{ borderRadius: "30px", ml: 2 }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6} lg={6}>
                    <Typography sx={styles.textside}>
                      Paste Url Instagram
                    </Typography>
                    <Box display="flex">
                      <img
                        src={insta}
                        alt="insta"
                        style={{ marginRight: "5%" }}
                      />
                      <CustomInput
                        name="urlInsta"
                        value={urlInsta?.value}
                        defaultValue={updateProfile?.urlInsta.value}
                        onChange={handleChangeWithTracking}
                        onFocus={handleFocus}
                        error={urlInsta.error}
                        sx={{ borderRadius: "30px", ml: 2 }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6} lg={6}>
                    <Typography sx={styles.textside} ms={4}>
                      Paste Url Facebook
                    </Typography>
                    <Box display="flex">
                      <img src={fb} alt="fb" style={{ marginRight: "5%" }} />
                      <CustomInput
                        name="urlFb"
                        defaultValue={updateProfile?.urlFb.value}
                        value={urlFb?.value}
                        onChange={handleChangeWithTracking}
                        onFocus={handleFocus}
                        error={urlFb.error}
                        sx={{ borderRadius: "30px" }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Box pb="5%">
          <LoadingButton
            loading={loading}
            variant="contained"
            type="submit"
            color="success"
            disabled={!hasFormChanges}
            sx={{
              borderRadius: 50,
              textTransform: "none",
              backgroundColor: "#28AA4A",
            }}
          >
            Save Changes
          </LoadingButton>
          <Button
            variant="contained"
            onClick={handleNavigate}
            color="success"
            sx={{
              borderRadius: 50,
              textTransform: "none",
              backgroundColor: "#878787",
              ml: 2,
            }}
          >
            Cancel
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default EditEmployeePage;
